import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AdapterService } from '../services/adapter.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private readonly _router: Router,
    private readonly _adapterService: AdapterService,
    private readonly _toastrService: ToastrService,
    private modalService: NgbModal) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(catchError(error => this.handleError(error)));
  }

  private handleError(error: any): Observable<HttpEvent<any>> {
    let errorMessage: string;
    if (error.error instanceof ErrorEvent) {
      // client-side Error
      errorMessage = `Error: ${error.error.message}`;

    } else { // Server-side Error
      errorMessage = `Error Code: ${error.status}. Message: ${error.message}`;
      if (error.status === 401) {
        errorMessage = `Error Code: ${error.status} - Unauthorized. Message: Invalid Token. The token is expired. ${error.message}`;
        this._adapterService.removeLocalStorageValue(environment.storageKeys.userInfo);
        this.modalService.dismissAll();
        this._toastrService.warning("Session expired");
        this._router.navigate(["/auth/login"]);
      }
    }

    if (typeof error.error === "undefined" || error.error === null)
      error.error = new Error(errorMessage);

    return throwError(error);
  }
}
